var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderswiftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.612 0 0 7.63 0 17.043 0 25.88 6.71 33.145 15.3 34v-8.003c0-.623-.386-1.16-.95-1.424-2.11-.987-3.48-3.187-3.604-6.034-.003-.054-.017-.107-.017-.163V11.64a1.021 1.021 0 0 1 2.041 0v7.026c0 .103.006.205.011.308.028.378.335.68.719.68a.73.73 0 0 0 .73-.73V11.64a1.021 1.021 0 1 1 2.04 0v7.283a.73.73 0 0 0 1.459 0V11.64a1.021 1.021 0 1 1 2.042 0v7.283c0 .403.326.73.728.73a.728.728 0 0 0 .72-.688c.004-.085.008-.172.008-.258V17.01h.003v-5.37a1.021 1.021 0 1 1 2.04 0v6.481l-.002.034v.222c0 .048-.01.094-.014.142-.118 2.856-1.487 5.064-3.602 6.054-.565.265-.95.803-.95 1.427v8C27.291 33.145 34 25.88 34 17.043 34 7.63 26.388 0 17 0",
    fill: "#E62123",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderswiftLogo);
export default __webpack_public_path__ + "static/media/orderswift_logo.4da08721375d438a7e5d3cfea07dd5b3.svg";
export { ForwardRef as ReactComponent };